import { FadeIn, Pulse, Reveal } from './components';

export const AnimatedViews = {
  FadeIn,
  Pulse,
  Reveal,
};
